import React from "react";
import * as Routes from "./routes/Routes";
import configRouters from "Configs/routes";
import { Route, Switch } from "react-router-dom";
import TariffsLayout from "Layouts/TariffsLayout";

const Rates = (props) => (
	<Switch>
		<Route exact path={configRouters.Rates.route} component={Routes.Rates} />
		<TariffsLayout
			exact
			path={configRouters.RatesTags.route}
			component={Routes.RatesTags}
			seoData={props.seoData}
			route={configRouters.RatesTags}
		/>
	</Switch>
);

export default Rates;
